import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import moment from "moment";
let PaymentJobsView = class PaymentJobsView extends Vue {
    constructor() {
        super();
        this.datesSelected = new Array();
        this.datesSelected.push(moment().format("YYYY-MM-DD"));
        this.searchDatesMenu = false;
    }
    async mounted() { }
    get selectedDatesFormatted() {
        let dateMessage = "No dates selected";
        if (this.datesSelected.length > 0) {
            dateMessage = moment(this.datesSelected[0]).format("YYYY-MM-DD");
        }
        if (this.datesSelected.length > 1) {
            dateMessage = dateMessage
                .concat(" to ")
                .concat(moment(this.datesSelected[1]).format("YYYY-MM-DD"));
        }
        return dateMessage;
    }
};
PaymentJobsView = tslib_1.__decorate([
    Component({
        name: "PaymentJobs",
        components: {}
    })
], PaymentJobsView);
export default PaymentJobsView;
